<template>
	<div class="banner" :class="[content.version, layout]">
		<div class="banner-icon" :style="{color: getFill}">
			<base-icon v-if="content.version === 'success'" class="check-icon" icon-name="check-circle" />
			<base-icon v-else class="info-icon" icon-name="info" />
		</div>
		<div class="banner-container">
			<div class="banner-top">
				<div class="banner-copy">
					<p :class="layout === 'large' ? 'caption-2' : 'subheading-1'">{{ content.title }}</p>
					<p v-if="layout !== 'html'" :class="layout === 'large' ? 'caption' : 'body-2'">
						{{ content.body }}
					</p>
					<div v-else class="large" v-html="content.body" />
				</div>
			</div>
			<div class="banner-bottom">
				<slot name="buttons">
					<md-button v-if="content.dismissible" class="md-primary md-button-large" @click="dismiss">
						Dismiss
					</md-button>
					<md-button
						v-if="content.btn && content.btnEmits"
						class="md-primary md-button-large"
						@click="emitButton(content.btnEmits)"
					>
						{{ content.btn }}
					</md-button>
				</slot>
			</div>
		</div>
	</div>
</template>
<script>
import loggingDevInfo from '@/services/log-dev-info';

export default {
	props: {
		content: {
			type: Object,
			required: true,
			validator: (content) => {
				/**
				 * Custom property validation for content prop
				 * @param {string}  title required - title text
				 * @param {string}  version  required, values: ['success', 'warning', 'info', 'error']
				 * @param {string}  body  - body text
				 * @param {string}  btn  - button text
				 * @param {string}  btnEmits  - $emits to $root
				 * @param {boolean} dismissible  - shows/hides dissmiss button
				 */
				const contentKeys = ['title', 'version'];
				const versionTypes = ['success', 'warning', 'info', 'error'];
				const contentVal = Object.values(content);
				// check types for props
				for (const prop in content) {
					if (
						(prop === 'dismissible' && typeof content[prop] !== 'boolean') ||
						(prop !== 'dismissible' && typeof content[prop] !== 'string')
					) {
						console.error(`Banner Prop  Error: ${prop} is not the correct type`);
						return false;
					}
				}
				// check for required props
				if (!contentKeys.every((key) => key in content)) {
					console.error('Banner Prop Error: title and version props are required');
					return false;
				}
				// check for correct version prop
				if (content.version?.length && !versionTypes.includes(content.version)) {
					console.error('Banner Prop Error: version can only be: success, warning, info, error');
					return false;
				}
				return true;
			},
		},
		layout: {
			type: String,
			default: 'large',
		},
	},
	name: 'Banner',
	methods: {
		dismiss() {
			this.$emit('closeBanner');
		},
		emitButton(text) {
			this.$root.$emit(text);
			this.dismiss();
		},
	},
	computed: {
		getFill() {
			// *Note: using non scss color vars for svg fill
			return this.content.version === 'info'
				? '#4c4c4c'
				: this.content.version === 'warning'
				? '#FFAB00'
				: this.content.version === 'success'
				? '#00963F'
				: '#E0003C';
		},
	},
	mounted() {
		try {
			if (
				!Number(
					document
						.querySelector('wca-header')
						?.shadowRoot.querySelector('wca-header-banner')
						?.getBoundingClientRect().height || 0,
				)
			) {
				$('#globalBannerContainer').css(
					'top',
					Number(document.querySelector('wca-header')?.getBoundingClientRect().height || 0),
				);
			}
			if (
				Number(
					document
						.querySelector('wca-header')
						?.shadowRoot.querySelector('wca-header-banner')
						?.getBoundingClientRect().height || 0,
				)
			) {
				document
					.querySelector('wca-header')
					?.shadowRoot.querySelector('wca-header-banner')
					?.shadowRoot.querySelector('.header-banner__close')
					.addEventListener('click', function () {
						$('#globalBannerContainer').css(
							'top',
							Number(document.querySelector('wca-header').getBoundingClientRect().height || 0),
						);
					});
			}
		} catch (error) {
			loggingDevInfo(error);
		}
	},
};
</script>
<style lang="scss">
.banner {
	display: flex;
	padding: 24px 24px 10px;
	justify-content: center;
	background-color: $color-extra-light-red;
	overflow: hidden;
	position: relative;
	z-index: 1;
	&.error,
	&.warning {
		.info-icon {
			transform: rotate(180deg);
		}
	}
	&.info {
		background-color: $color-light-grey;
	}
	&.warning {
		background-color: $color-extra-light-yellow;
	}
	&.success {
		background-color: $color-extra-light-green;
	}
	&-icon {
		margin-right: 18.67px;
	}
	&-container {
		max-width: 558px;
	}
	&-bottom {
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
	}
	&.small {
		justify-content: flex-start;
		padding: 16px 24px;
		.banner-icon {
			font-size: 26px;
			margin-right: 10px;
		}
		.banner-container {
			display: flex;
			max-width: 100%;
			flex-wrap: wrap;
			.banner-top {
				padding-right: 20px;
				flex: 1 1 80%;
			}
			.banner-bottom {
				align-self: center;
			}
			.banner-copy > p {
				margin: 0;
			}
		}
	}
}
</style>
